/**
 * Layout.js
 *
 * Route wrapper for the unauthenticated "find schools" feature. Keeps routing
 * concerns minimal — all UI/logic lives in src/features/find_schools.
 *
 * Google Maps is loaded by the app's single root APIProvider (see App.js);
 * this feature loads the Places library on demand via `useMapsLibrary('places')`.
 */
import React from 'react';
import { FindSchools } from '@/features/find_schools';

export default function Layout() {
  return <FindSchools />;
}
